export const DELIVERY_TIME_FORMATS: any = [];
DELIVERY_TIME_FORMATS.HOUR = "hrs";
DELIVERY_TIME_FORMATS.DAY = "days";
